import {isValid} from 'validators/number-validator';

export const getAttribute = (name, value) => {
  if (name && value) {
    return [name, '="', value, '"'].join('');
  }
  return '';
};

export const getClipPath = (clipPathID) => {
  return clipPathID && typeof clipPathID === 'string'
    ? `url(#${clipPathID})`
    : '';
};

export const getMask = (maskID) => {
  return maskID && typeof maskID === 'string' ? `url(#${maskID})` : '';
};

export const getRotate = (angle, x = 0, y = 0) => {
  if (isValid(angle) && isValid(x) && isValid(y)) {
    return ['rotate(', [angle, x, y].join(' '), ')'].join('');
  }
  return '';
};

export const getTranslate = (x, y) => {
  if (!isValid(x) || !isValid(y)) {
    return '';
  }
  const ceilX = Math.ceil(x);
  const ceilY = Math.ceil(y);
  return `translate(${ceilX},${ceilY})`;
};
